export default __webpack_public_path__ + "../staticImages/winefinder-sprite-Wein_Brandy-2x.png";